import { indexData } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              剧集分类索引
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              按类型快速找到你想看的电视剧
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
            {indexData.map((item) => (
              <a
                key={item.id}
                href="#media"
                className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-50 rounded-lg border border-secondary-200/70 hover:border-primary-300 hover:bg-secondary-50 transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <div className="text-center">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{item.count}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}